/**
 * Created by maduka on 5/30/19.
 */
(function () {
  'use strict';

  angular
    .module('rosterScoringReport')
    .controller('ScoringPopupCtrl', ScoringPopupCtrl);

  function ScoringPopupCtrl(modalParams,$uibModalInstance) {
    var vm = this;

    vm.model = {
      scores : modalParams.scoringDetails,
      totScore:modalParams.score,
      totalDesirability:modalParams.totalDesirability,
      totalScorePercentage:modalParams.totalScorePercentage
    };

    vm.onCloseClick = function () {
      $uibModalInstance.close(modalParams.close);
    }
  }
}());
